import Evented from '@ember/object/evented';
import Service from '@ember/service';

// eslint-disable-next-line ember/no-classic-classes
export default class MessageBusService extends Service.extend(Evented, {}) {}
